import { createDraftSafeSelector } from '@reduxjs/toolkit'
import { CommonStateType } from '../reducer/common.reducer'
import { RootState } from '../store'
import { OptionChainTableView } from '../pages/home/fnoHeader/optionsChainSettingsDialog'

const state = (state: RootState) => state

export const selectCommonStore = createDraftSafeSelector(state, (store: RootState) => store.commonStore as CommonStateType)

/** Narrow fields so App shell does not re-render when unrelated commonStore fields change. */
export const selectApiErrorState = createDraftSafeSelector(
    [
        (state: RootState) => state.commonStore.apiError,
        (state: RootState) => state.commonStore.errorMessage,
        (state: RootState) => state.commonStore.errorType
    ],
    (apiError, errorMessage, errorType) => ({ apiError, errorMessage, errorType })
)

export const selectRightSidebarWidget = createDraftSafeSelector(state, (state: RootState) => state.commonStore.rightSideWidget)

export const selectOverviewIndexComponentsSortedBy = createDraftSafeSelector(
    (state: RootState) => state.commonStore.overviewIndexComponentsSortedBy,
    (sortedBy) => sortedBy
)

export const selectCommonSelectedColumnSet = createDraftSafeSelector(
    (state: RootState) => state.commonStore.selectedColumnSet,
    (selectedColumnSet) => selectedColumnSet
)

export const selectTimezone = createDraftSafeSelector(state, (store: RootState) => store.commonStore.timezone as CommonStateType['timezone'])

export const selectRecentExpressions = createDraftSafeSelector(state, (store: RootState) => store.commonStore.recentlyUsedExpressions)

export const selectStrategyExpressionsMetaData = createDraftSafeSelector(state, (store: RootState) => store.commonStore.strategyExpressionMetaData as CommonStateType['strategyExpressionMetaData'])

export const selectRecentExpressionsRefreshTime = createDraftSafeSelector(state, (store: RootState) => store.commonStore.recentExpressionsRefreshedTime)

export const selectCurrentTheme = createDraftSafeSelector((state: RootState) => state.commonStore, (commonStore) => commonStore.darkTheme as boolean);

export const selectThemeMode = createDraftSafeSelector(
  (state: RootState) => state.commonStore,
  (commonStore) => commonStore.themeMode as 'Light' | 'Dark' | 'System'
)


export const selectNavigationUrls = createDraftSafeSelector(state, (store: RootState) => store.commonStore.navigationUrls as CommonStateType['navigationUrls'])

export const selectMultiPaneFullScreen = createDraftSafeSelector(state, (store: RootState) => store.commonStore.container)

export const selectMarketDepthSecurity = createDraftSafeSelector(state, (store: RootState) => store.commonStore.marketDepthSecurity)

export const selectWidgetPaneId = createDraftSafeSelector(state, (store: RootState) => store.commonStore.widgetPaneId)

export const FullScreenToggle = createDraftSafeSelector(state, (store: RootState) => store.commonStore.isFullScreen)

export const selectOptionChainVisibleStrikes = createDraftSafeSelector(state, (store: RootState) => store.commonStore.optionChainVisibleStrikes)

export const selectOptionChainTableView = createDraftSafeSelector(state, (store: RootState) => store.commonStore.optionChainTableView as OptionChainTableView)

export const selectShowOptionChainQuantityInLots = createDraftSafeSelector(state, (store: RootState) => store.commonStore.showOptionChainQuantityInLots)

export const selectCalendarWeekCardsExpanded = createDraftSafeSelector(
    state,
    (store: RootState) => store.commonStore.calendarWeekCardsExpanded ?? true
)

export const selectCustomColors = createDraftSafeSelector(state, (store: RootState) => store.commonStore.customColors as string[])